module.exports = __webpack_public_path__ + "img/step3-3.35fa9cb6.png";